import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import { StartAnimation } from '../AnimationHelper';
import WinStarEffect from '../../../Prototype/Effect/WinStarEffect';
import { delay } from '../../../Utility/Task/TaskQueue';
import Point from '../../../Utility/Point';
import {
    AUDIO_WIN_SEQUENCE_STAR_1,
    AUDIO_WIN_SEQUENCE_STAR_2,
    AUDIO_WIN_SEQUENCE_STAR_3,
} from '../../Audio';
import { StartAudio } from '../../Audio/AudioHelper';
import Scene from '../../../Scene/Scene';
import { AudioTrackType } from '../../Audio/AudioClip';

interface ILevelCompleteMenuMeta {
    fail: boolean;
    score: number;
    coins: number;
    stars: number;
    scene: Scene;
}

export class LevelCompleteMenu extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta: ILevelCompleteMenuMeta
    ): IterableIterator<number> {
        const TXT_SCORE: string = 'main_container/result_score/value_text';
        const TXT_COINS: string = 'main_container/result_coins/value_text';
        const STAR1: string = 'main_container/star_container/star1';
        const STAR2: string = 'main_container/star_container/star2';
        const STAR3: string = 'main_container/star_container/star3';

        const txtScore = gameObject.find(TXT_SCORE);
        const txtCoins = gameObject.find(TXT_COINS);
        const stars = [
            gameObject.find(STAR1),
            gameObject.find(STAR2),
            gameObject.find(STAR3),
        ].slice(0, meta.stars);

        const duration: number = 500 * (meta.stars || 1);

        StartAnimation(txtScore, 'Counter', {
            startValue: 0,
            finalValue: meta.score,
            duration: duration,
        });

        StartAnimation(txtCoins, 'Counter', {
            startValue: 0,
            finalValue: meta.coins,
            duration: duration,
        });

        const audioStarClips = [
            AUDIO_WIN_SEQUENCE_STAR_1,
            AUDIO_WIN_SEQUENCE_STAR_2,
            AUDIO_WIN_SEQUENCE_STAR_3,
        ];

        for (let i = 0, n = stars.length; i < n; i++) {
            this.starEffect(stars[i], meta.scene, audioStarClips[i]);
            yield* delay(500);
        }
    }

    private starEffect(
        parent: GameObject,
        scene: Scene,
        audioClip: string
    ): void {
        const winStarEffect = GameObject.Instantiate(WinStarEffect, {
            pivot: new Point(-60, -60),
        });
        parent.addChild(winStarEffect);
        StartAudio(scene, audioClip, AudioTrackType.SFX);
    }
}
